import { Id } from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { convertUserSettings } from 'settings/queries/shared/convert'
import * as SettingsRepsonse from 'settings/queries/shared/response'
import { UserSettingsData } from 'settings/queries/shared/types'
import keys from './shared/keys'

export function useStorePreferences(
  storeId: Id | undefined,
  enabled: boolean = true
) {
  const { server } = useServer()

  return useQuery<UserSettingsData>({
    queryKey: storeId ? keys.storePreference(storeId) : [],
    queryFn: fetchStorePreferences,
    enabled: !!storeId && enabled,
  })

  async function fetchStorePreferences() {
    if (!storeId) {
      throw new Error('Illegal store ID')
    }

    const url = `/v2/stores/${storeId}/attributes`

    const response = await server.get<SettingsRepsonse.Settings>(url)

    return convertUserSettings(response, url)
  }
}
